import LoginView from "@/views/LoginView.vue";

const routes = [
  {
    path: "/anmelden",
    name: "login",
    component: LoginView,
  },
  {
    path: "/",
    redirect: "/welcome",
    name: "home",
  },
  {
    path: "/welcome",
    name: "welcomeScreen",
    component: () => import("../views/WelcomePageView"),
  },
  {
    path: "/zuordnen",
    name: "treatmentAssignment",
    component: () => import("../views/TreatmentAssignmentView"),
  },
  {
    path: "/absetzungen",
    name: "absetzungen",
    component: () => import("../views/AbsetzungView"),
  },
  {
    path: "/zuzahlungsstatus",
    name: "zuzahlungsstatus",
    component: () => import("../views/ZuzahlungsstatusView"),
  },
  {
    path: "/therapeutenwechsel",
    name: "therapeutenwechsel",
    component: () => import("../views/TherapeutenwechselView"),
  },
  {
    path: "/teilabsetzung",
    name: "teilabsetzung",
    component: () => import("../views/TeilAbsetzungView"),
  },
  {
    path: "/komplettabsetzung",
    name: "komplettabsetzung",
    component: () => import("../views/KomplettAbsetzungView"),
  },
  {
    path: "/alleAbsetzungen",
    name: "alleAbsetzungen",
    component: () => import("../views/AlleAbsetzungView"),
  },
  {
    path: "/berichte",
    name: "reports",
    component: () => import("../views/ReportsView.vue"),
  },
  {
    path: "/nutzer",
    name: "userManagement",
    component: () => import("../views/UserManagementView.vue"),
  },
  {
    path: "/ttoolsDatev",
    name: "ttoolsDatev",
    component: () => import("../views/TtoolsDatevView.vue"),
    beforeEnter: (to, from, next) => {
      next(process.env.VUE_APP_ENABLE_ACCOUNTING === "true");
    },
  },
  {
    path: "/ttoolsBuchhaltung",
    name: "ttoolsBuchhaltung",
    component: () => import("../views/TtoolsBuchhaltungView.vue"),
    beforeEnter: (to, from, next) => {
      next(process.env.VUE_APP_ENABLE_ACCOUNTING === "true");
    },
  },
  {
    path: "/ttoolsEagle",
    name: "ttoolsEagle",
    component: () => import("../views/TtoolsEagleView.vue"),
    beforeEnter: (to, from, next) => {
      next(process.env.VUE_APP_ENABLE_ACCOUNTING === "true");
    },
  },
  {
    path: "/importieren",
    name: "import",
    component: () => import("../views/FileUploadView.vue"),
  },
  {
    path: "/therapeuten",
    name: "therapists",
    component: () => import("../views/TherapistManagementView.vue"),
  },
];

export default routes;
